<template>
  <div id="app">
    <commonhead :active_menu="-1" />
    <div class="user_center_info my_style myinfo_style">
      <div class="content_wrap">
        <!--个人中心公用侧边栏-->
        <div class="current_title">个人设置</div>
        <div class="left_content">
          <div class="link_item link_item_active">
            个人设置
          </div>
          <div class="link_item" @click="$router.push('/user-center-pwd')">
            修改密码
          </div>
        </div>
        <div class="right_content">
          <p class="head_title">基本资料</p>
          <div class="image">
            <span class="av">
              <img :src="avatar" alt class="pic_full" />
            </span>
            <span class="up_file pr dib">
              <button class="up_btn hand_point">上传头像</button>
              <input
                type="file"
                @change="up_av($event)"
                class="up_file_btn hand_point"
                :disabled="can_edit"
              />
            </span>
          </div>
          <div class="item">
            <span class="head">
              昵称
            </span>
            <input
              type="text"
              placeholder="名字"
              class="name"
              v-model="user_name"
              :disabled="can_edit"
            />
          </div>
          <div class="item">
            <span class="head">
              性别
            </span>
            <span class="sex">
              <span class="icon hand_point icon_active" v-if="sex == 1"></span>
              <span class="icon hand_point" v-if="sex != 1" @click="change_sex(1)"></span>
              <span class="dib">男同学</span>
            </span>
            <span class="sex">
              <span class="icon hand_point icon_active" v-if="sex == 0"></span>
              <span class="icon hand_point" v-if="sex != 0" @click="change_sex(0)"></span>
              <span class="dib">女同学</span>
            </span>
          </div>
          <div class="item itemfix">
            <span class="head">
              生日
            </span>
            <DatePicker
              v-model="birth"
              type="date"
              placeholder="选择日期"
              :disabled="can_edit"
              value-format="yyyy-MM-dd"
            ></DatePicker>
            <button class="edit_btn hand_point" @click="save_info">{{btn_info}}</button>
          </div>
          <div class="divider"></div>
          <p class="head_title">地址管理</p>
          <div class="addressbox">
            <div class="address-left">
              <div class="item">
                <span class="head">所在地区：</span>
                <div class="dist_picker">
                  <v-distpicker @selected="onSelected" :disabled="can_editmore" :province="province" :city="city" :area="district"></v-distpicker>
                </div>
              </div>
              <div class="item">
                <span class="head">详细地址：</span>
                <input type="text" class="name" v-model="address" :disabled="can_editmore" />
              </div>
              <div class="item">
                <span class="head">收&emsp;件&emsp;人：</span>
                <input type="text" class="name" v-model="recipient" :disabled="can_editmore" />
              </div>
              <div class="item itemfix">
                <span class="head">联系手机：</span>
                <input type="text" class="name" v-model="recipient_mobile" :disabled="can_editmore" />
              </div>
            </div>
            
            <div class="address-right">
              <button class="addressedit_btn hand_point" @click="save_infomore">{{btn_infomore}}</button>
            </div>
          </div>
          <div class="divider"></div>
          
          <p class="head_title">短信提醒</p>
          <p class="notice_info">开启后，您将在上课前30分钟收到短信提醒</p>
          <div class="info_area">
            <div class="item">
              <span class="key">您的手机号是</span>
              <span class="value">{{user_info.mobile}}</span>
            </div>
            <div class="item dif">
              <span class="key">开启或关闭短信提醒</span>
              <span class="icon hand_point" v-if="!btn_turn" @click="change_btn(true)">
                <img src="../../assets/image/user_center/btn (1).png" alt class="pic_full" />
              </span>
              <span class="icon hand_point icon_on" v-if="btn_turn" @click="change_btn(false)">
                <!-- <img src="../../assets/image/user_center/btn (2).png" alt class="pic_full" /> -->
                <div class='icon_text'>开启</div>
                <div class='icon_circle'></div>
              </span>
            </div>
          </div>
          <p class="tips">注意：</p>
          <p class="tips_text">1、首次充值学贝后激活该功能。</p>
          <p class="tips_text">2、短信有程序控制不会漏发、迟发，如果没有收到可能是受您的手机网络运营商和信号影响。</p>
        </div>
      </div>
    </div>
    <!--底部信息-->
    <div class="bottombox">
      <commonbottom />
    </div>
    <!--公共底部-->
    <commonfoot />
    <!--公共底部-->
  </div>
</template>

<script>
import { common } from "../../../common.js";
import commonhead from "../common/common_head.vue";
import commonfoot from "../common/common_foot.vue";
import commonbottom from "../common/common_bottom";
import { DatePicker } from "element-ui";
import VDistpicker from "v-distpicker";
export default {
  name: "app",
  components: {
    commonhead,
    commonfoot,
    DatePicker,
    VDistpicker,
    commonbottom
  },
  data: function() {
    return {
      sex: 1, //1男0女
      user_name: "",
      birth: "",
      user_info: "",
      can_edit: true,
      city: "",
      btn_info: "编辑",
      avatar: "",
      btn_turn: false,
      can_editmore: true,
      btn_infomore: "编辑",
      province: '',
      district: '',
      address: '',
      recipient: '',
      recipient_mobile: ''
    };
  },
  mounted: function() {
    this.get_info();
  },
  methods: {
    change_sex(type) {
      if (!this.can_edit) {
        this.sex = type;
      }
    },
    onSelected(data) {
      this.province = data.province.value;
      this.city = data.city.value;
      this.district = data.area.value;
    },
    get_info() {
      let self = this;
      common.requestFun(self, "get", "/student/profile", {}, res => {
        if (res.data.code == 200) {
          const resdata = res.data.data;
          self.user_info = res.data.data;
          self.sex = res.data.data.gender;
          self.user_name = res.data.data.name;
          self.birth = res.data.data.birthday;
          self.city = res.data.data.city;
          self.avatar = res.data.data.avatar;
          self.btn_turn = res.data.data.use_notify == 1 ? true : false;
          self.province = resdata.province;
          self.district = resdata.district;
          self.address = resdata.address;
          self.recipient = resdata.recipient;
          self.recipient_mobile = resdata.recipient_mobile;
        } else {
          if (res.data.msg && res.data.code == 401) {
            self.$message({
              message: "请登录",
              type: "error",
              center: true,
            });
          }
          self.$router.push("./");
        }
      });
    },
    submit_info() {
      let self = this;
      common.requestFun(
        self,
        "post",
        "/student/update",
        {
          birthday: self.birth,
          gender: self.sex,
          name: self.user_name,
          avatar: self.avatar
        },
        res => {
          if (res.data.code == 200) {
            self.$message({
              showClose: true,
              message: res.data.msg,
              type: "success"
            });
          } else {
                if (res.data.msg) {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true
              });
            }
          }
        }
      );
    },
    up_av(e) {
      //上传头像
      let self = this;
      var file = e.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function() {
        let _this = this;
        common.requestFun(
          self,
          "post",
          "/upload/base64",
          {
            file: _this.result
          },
          res => {
            if (res.data.code == 200) {
              self.$message({
                showClose: true,
                message: res.data.msg,
                type: "success"
              });
              self.avatar = res.data.data.url;
            } else {
                  if (res.data.msg) {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true
              });
            }
            }
          }
        );
      };
    },
    save_info() {
      this.can_edit = this.can_edit ? false : true;
      this.btn_info = this.can_edit ? "编辑" : "保存";
      if (this.can_edit) {
        this.submit_info();
      }
    },
    change_btn(type) {
      let self = this;
      common.requestFun(
        self,
        "post",
        "/student/course/notify",
        {
          use: type ? 1 : 0
        },
        res => {
          if (res.data.code == 200) {
            self.$message({
              showClose: true,
              message: "设置成功",
              type: "success"
            });
            self.btn_turn = type;
          } else {
                if (res.data.msg) {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true
              });
            }
          }
        }
      );
    },
    save_infomore(){
      if(!this.can_editmore){
        // 检查空
        if(!this.province||!this.city||!this.district){
          this.$message({
                message: "请选择所在地区",
                type: "error",
                center: true
          });
          return;
        }
        if(!this.address){
          this.$message({
                message: "请填写详细地址",
                type: "error",
                center: true
          });
          return;
        }
        if(!this.recipient){
          this.$message({
                message: "请填写收件人",
                type: "error",
                center: true
          });
          return;
        }
        if(!this.recipient_mobile){
          this.$message({
                message: "请填写联系手机",
                type: "error",
                center: true
          });
          return;
        }
        if(this.recipient_mobile&&!this.checkPhone(this.recipient_mobile)){
          this.$message({
                message: "请填写正确的联系手机",
                type: "error",
                center: true
          });
          return;
        }

      }
      this.can_editmore = this.can_editmore ? false : true;
      this.btn_infomore = this.can_editmore ? "编辑" : "保存";
      if (this.can_editmore) {
        this.submit_infomore();
      }
    },
    checkPhone(phone) {
      //检测手机号合法性
      let reg = /^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8]|8[0-9]|9[1,8,9])\d{8}$/;
      return reg.test(phone);
    },
    submit_infomore() {
      let self = this;
      common.requestFun(
        self,
        "post",
        "/student/update",
        {
          province: self.province,
          district: self.district,
          city: self.city,
          address: self.address,
          recipient: self.recipient,
          recipient_mobile: self.recipient_mobile
        },
        res => {
          if (res.data.code == 200) {
            self.$message({
              showClose: true,
              message: res.data.msg,
              type: "success"
            });
          } else {
                if (res.data.msg) {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true
              });
            }
          }
        }
      );
    },
  }
};
</script>
<style scoped src="./user_center_info.css"></style>
<style>
.my_style .el-date-editor.el-input{
  width: 358px;
}
.my_style .el-date-editor.el-input__inner {
    width: 358px;
    height: 36px;
    border: 1px solid #dedede;
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFang;
    font-weight: 400;
    color: #666;
    text-indent: 10px;
    outline: none;
    box-sizing: border-box;
}
.dist_picker .distpicker-address-wrapper select {
  width: 116px;
  outline: none;
}
.dist_picker .distpicker-address-wrapper select[disabled] {
  background-color: rgba(239, 239, 239, 0.3);
}
</style>